export const estimatedTaxPaymentsContext = {
    taxPayer: "",
    date: "",
    federal: "",
    state: "",
    stateCnt: ""
}